import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import trans from 'translate';
import { useHistory } from 'react-router-dom';
import { CREATE_HPOOL_STEPS } from 'constants/createHPool';
import ModalBody from '../../../Modals/ModalBody';
import './CreateHPoolSignTransaction.scss';
import SignOnOverview from './SignOnOverview/SignOnOverview';
import EditTradeOrders from './EditTradeOrders/EditTradeOrders';
import { createOrUpdateHPoolAction } from '../../../../redux/actions/createHPoolActions';
import { useAssetsSignatures } from '../../../../hooks/useAssetsSignatures';
import config from '../../../../config/config.json';

export const hPoolSignTransactionContext = createContext({
  selectedToken: null,
  setSelectedToken: () => {},
  tradeOrders: [],
  addedTokens: [],
  closeSignTxModal: () => {},
});

const CreateHPoolSignTransaction = ({
  hPoolId,
  createOrUpdateHPoolAction,
  assetSignatures,
  addedTokens,
  closeModal,
}) => {
  const history = useHistory();
  const [, , isSigned] = useAssetsSignatures();
  const createHPool = useSelector((state) => state.createHPool);
  const { tradeOrders } = createHPool;
  const [selectedToken, setSelectedToken] = useState(null);
  const {
    hpool: { id: hpoolId },
  } = createHPool;

  useEffect(() => {
    if (
      tradeOrders
        .filter((tradeOrder) => tradeOrder.token_symbol.toLowerCase() !== config.baseCoin.toLowerCase())
        .every((tradeOrder) => isSigned(tradeOrder.token_id))
    ) {
      const updatedAssetSignatures = { asset_signatures: assetSignatures, id: hPoolId };
      createOrUpdateHPoolAction(updatedAssetSignatures);
      closeModal();
    }
  }, [assetSignatures, closeModal, tradeOrders, history]);

  const contextValue = {
    selectedToken,
    setSelectedToken,
    tradeOrders,
    addedTokens,
  };

  const goToPreviousStep = () => {
    history.push(`/create-pool/${CREATE_HPOOL_STEPS[3].path}`);
    closeModal();
  };

  const modalTitle = selectedToken ? 'createHpool.edit_order' : 'createHpool.sign_tx';
  const translatedTitle = trans(modalTitle);

  return (
    <div className="hpool-sign-transaction-wrapper">
      <ModalBody title={translatedTitle} closeModal={goToPreviousStep} onBack={goToPreviousStep}>
        <hPoolSignTransactionContext.Provider value={contextValue}>
          {selectedToken ? (
            <EditTradeOrders selectedToken={selectedToken} />
          ) : (
            <SignOnOverview hpoolId={hpoolId} closeModal={closeModal} goToPreviousStep={goToPreviousStep} />
          )}
        </hPoolSignTransactionContext.Provider>
      </ModalBody>
    </div>
  );
};

CreateHPoolSignTransaction.defaultProps = {
  assetSignatures: {},
  hPoolId: null,
};

CreateHPoolSignTransaction.propTypes = {
  addedTokens: PropTypes.array.isRequired,
  closeModal: PropTypes.func.isRequired,
  assetSignatures: PropTypes.object,
  createOrUpdateHPoolAction: PropTypes.func.isRequired,
  hPoolId: PropTypes.number,
};

const mapStateToProps = ({ createHPool }) => ({
  addedTokens: createHPool.addedTokens,
  assetSignatures: createHPool.assetSignatures,
  hPoolId: createHPool.hpool?.id,
});

export default connect(mapStateToProps, { createOrUpdateHPoolAction })(CreateHPoolSignTransaction);
